module.exports = __webpack_public_path__ + "static/media/vertex-7002x.979fdff0.jpg";